// src/legal/legalVersions.js
// Which version of the Terms and Privacy Policy a new registrant agrees to.
// Recorded on their user profile (termsAcceptedVersion / privacyPolicyVersion).
// The documents themselves are public/legal/terms.md and privacy.md, shown
// at /terms and /privacy. Bump these whenever the published text changes.
export const LEGAL_VERSIONS = {
  terms: '2026-10-05.2',
  privacy: '2026-10-05.2'
};
